import { render, staticRenderFns } from "./group.vue?vue&type=template&id=5b520f45&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=5b520f45&prod&lang=css"
import style1 from "./group.vue?vue&type=style&index=1&id=5b520f45&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b520f45",
  null
  
)

export default component.exports